module.exports = __webpack_public_path__ + "img/AI Icon.296f8ca1.svg";